import React from "react";

const makeReference = () => `UI-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, reference: "" };
  }

  static getDerivedStateFromError() {
    return { hasError: true, reference: makeReference() };
  }

  componentDidCatch(error, info) {
    console.error("Application render error", {
      reference: this.state.reference,
      message: error?.message,
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <main className="min-h-screen bg-slate-50 flex items-center justify-center p-5">
        <section className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-6 shadow-sm text-center">
          <div className="mx-auto mb-4 h-11 w-11 rounded-full bg-red-50 text-red-600 flex items-center justify-center text-xl font-bold">!</div>
          <h1 className="text-xl font-bold text-slate-900">Ekran yüklenirken bir sorun oluştu</h1>
          <p className="mt-2 text-sm text-slate-600">Verileriniz silinmedi. Sayfayı yeniden yükleyerek güvenli şekilde devam edebilirsiniz.</p>
          <button type="button" onClick={() => window.location.reload()} className="mt-5 h-11 w-full rounded-xl bg-blue-600 px-4 font-semibold text-white hover:bg-blue-700">Sayfayı Yeniden Yükle</button>
          <p className="mt-4 text-xs text-slate-400">Hata referansı: {this.state.reference}</p>
        </section>
      </main>
    );
  }
}
